import { Field, Formik } from 'formik'
import { ReactElement, useCallback, useEffect, useRef } from 'react'
import { useRecoilValue } from 'recoil'
import { IProfit } from '../types/types'
import { api } from '../utils/api'
import { currenciesState } from '../states/currencies-state'
import { v4 } from 'uuid'
import { FormikProps } from 'formik/dist/types'
import { useAddProfit } from '../states/profits-state'

interface FormErrors {
  name?: string
  codename?: string
}

const INITIAL_VALUES: Partial<IProfit> = {
  id: undefined,
  amount: 0,
  currency: undefined,
  realizedAt: undefined,
}

const ProfitForm = (): ReactElement => {
  const addProfit = useAddProfit()
  const currencies = useRecoilValue(currenciesState)

  const formRef = useRef<FormikProps<IProfit>>(null)
  const onSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
        id: v4(), // Generate a new id
      }

      const { data } = await api.post('profit', payload)

      if (data.profit) {
        resetForm()
        // Log user
        addProfit(data.profit)
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  useEffect(() => {
    if (
      currencies &&
      currencies.length > 0 &&
      formRef.current &&
      !formRef.current.values.currency
    ) {
      // Set default currency
      formRef.current.setFieldValue('currency', currencies[0].id)
    }
  }, [])

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit} innerRef={formRef}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <Field
            type="currency"
            name="amount"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Eg. 1000"
            value={values.codename}
            className="input input-bordered w-full min-w-8 mb-4"
          />
          <Field
            className="select select-bordered w-full min-w-8 mb-4"
            component="select"
            id="currency"
            name="currency">
            {currencies?.map((currency) => {
              return (
                <option key={currency.id} value={currency.id}>
                  {currency.name} ({currency.code})
                </option>
              )
            })}
          </Field>

          <button type="submit" className="btn btn-outline" disabled={isSubmitting}>
            Submit
          </button>
        </form>
      )}
    </Formik>
  )
}

export default ProfitForm